import React from 'react';
import cn from 'classnames';
import Image from 'next/image';

import CTA from 'react-scale/components/ui/cta';
import MeshBackground from 'react-scale/components/ui/webgl';

const Hero = ({ theme, title, subtitle, icon, cta, bgAnimated, img = false }) => (
  <div>
    {bgAnimated && theme === 'dark' && <MeshBackground />}
    <div className="text-center py-18 lg:py-28 lg:p-24">
      <div className="container relative">
        {icon && (
          <Image
            src={icon.src}
            alt={icon.alt}
            width={icon.width ?? 56}
            height={icon.height ?? 64}
            loading="eager"
            priority
          />
        )}
        <h1
          className={cn(
            textTheme[theme],
            'font-aeonik text-4xl md:text-5xl mb-12 md:mb-4 mt-8 md:mt-4'
          )}
        >
          {title}
        </h1>
        <p
          className={cn(textTheme[theme], 'text-lg max-w-4xl mx-auto mb-16 md:mb-9 px-10 sm:px-0')}
        >
          {subtitle}
        </p>
        {cta && (
          <div className="flex justify-center">
            <CTA theme={theme} cta={cta} />
          </div>
        )}
      </div>
    </div>
    {img && (
      <div className="relative py-60 md:py-72 lg:py-80">
        <Image
          src={
            img.src ||
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F9f234cbf261d451fae882a090de10d02'
          }
          alt={img.alt}
          unoptimized
          layout="fill"
          objectFit="cover"
          objectPosition="bottom"
          quality={100}
        />
      </div>
    )}
  </div>
);

const textTheme = {
  dark: 'text-white',
  light: 'text-black'
};

Hero.defaultProps = {
  theme: 'dark',
  title: 'Title',
  cta: false,
  webgl: false,
  img: false
};

export default Hero;
